export class CreditoModel {
    constructor(
        public idcredito: number,
        public idcliente: number,
        public fecha: Date,
        public concepto: string,
        public productos: string
    ) { }
}